import type { ReactNode } from "react";
import { EyeOff } from "lucide-react";
import { usePrivacy } from "../../components/Privacy";

export default function ChartFrame({ children }: { children: ReactNode }) {
  const { hidden } = usePrivacy();
  return hidden ? (
    <div className="insight-chart-private"><EyeOff size={22} /><p>Show amounts to see this chart.</p></div>
  ) : <div className="insight-chart-frame">{children}</div>;
}
